enum RiskKey {
	SAFE = 'SAFE',
	HAZARDOUS = 'HAZARDOUS'
}

type Risk = RiskKey.SAFE | RiskKey.HAZARDOUS;

export interface StrainIndexDTO {
	left_risk: Risk;
	right_risk: Risk;
	score_left_rsi: string;
	score_right_rsi: string;
	score_left_borg_scale: string;
	score_right_borg_scale: string;
	score_left_exertion_duration: string;
	score_right_exertion_duration: string;
	score_left_efforts_per_minute: string;
	score_right_efforts_per_minute: string;
	score_left_wrist_posture: string;
	score_right_wrist_posture: string;
	score_left_daily_duration: string;
	score_right_daily_duration: string;
}

type Guidance = {
	left: string;
	right: string;
};

export type OverallScoreParameters = {
	left: string;
	right: string;
	risk: {
		left: Risk;
		right: Risk;
	};
};

export type OverallDetailedParameters = {
	intensity_of_exertion: Guidance;
	exertion_duration: Guidance;
	efforts_per_minute: Guidance;
	wrist_posture: Guidance;
	daily_duration: Guidance;
};

export enum Diagnostics {
	SAFE = 'Job is probably safe',
	HAZARDOUS = 'Job is probably hazardous'
}
